module.exports = __webpack_public_path__ + "img/cm.76fe00c5.jpg";